import sl from './sl.json'
import en from './en.json'
import { Lang } from '../../reducers/uiReducer'
import { slovenianLanguageEnabled } from '../../constants'

const langs: Record<Lang, Record<string, string>> = {
  [Lang.SL]: sl as Record<string, string>,
  [Lang.EN]: en as Record<string, string>,
}

if (process.env.NODE_ENV === 'development' && slovenianLanguageEnabled) {
  Object.keys(langs[Lang.EN]).forEach(key => {
    if (!(key in langs[Lang.SL])) {
      console.log(`missing key "${key}" (SL)`)
    }
  })
  Object.keys(langs[Lang.SL]).forEach(key => {
    if (!(key in langs[Lang.EN])) {
      console.error(`found invalid key "${key}" in SL dict`)
    }
  })
}

export const text = (lang: Lang, key: string): string => {
  const effectiveLang = slovenianLanguageEnabled ? lang : Lang.EN
  if (key in langs[effectiveLang]) {
    return langs[effectiveLang][key]
  }
  // general fallback to English if translation is missing
  if (effectiveLang !== Lang.EN && key in langs[Lang.EN]) {
    return langs[Lang.EN][key]
  }
  // return key if translation was not found
  return key
}

const SL_TEST_OVERRIDES: Record<string, string> = {
  'info_modal.dev_status_info': 'test test test',
  'info_modal.problem.content': 'test test test',
  'info_modal.solution.content': 'test test test',
  'info_modal.method.content.enfuser.description': 'test test test',
  'info_modal.method.content.noise_data.description': 'test test test',
  'info_modal.method.content.osm.description': 'test test test',
  'info_modal.method.content.otp.description_1': 'test test test',
  'info_modal.method.content.otp.description_2': 'test test test',
  'info_modal.method.content.gvi.description_1': 'test test test',
  'info_modal.team.content.developed_by': 'test test test',
  'info_modal.team.content.developed_by.suffix': 'test test test',
  'info_modal.team.content.within_the': 'test test test',
  'info_modal.team.content.hope_description': 'test test test',
  'info_modal.funded_by': 'test test test',
}

export const getErrorNotifKey = (errorKey: string): string => {
  const errorNotifKey = 'notif.error.routing.' + errorKey
  if (errorNotifKey in langs[Lang.EN]) {
    return errorNotifKey
  } else if (process.env.NODE_ENV === 'development') {
    console.error('Received unknown error key:', errorNotifKey)
  }
  return 'notif.error.routing.general_routing_error'
}

const dictionary = (lang: Lang) => {
  const effectiveLang = slovenianLanguageEnabled ? lang : Lang.EN
  const dict = langs[effectiveLang]
  if (slovenianLanguageEnabled && lang === Lang.SL) {
    return { ...dict, ...SL_TEST_OVERRIDES }
  }
  return dict
}

export default dictionary
